<template>
  <div class="d-flex flex-column gap-4">
    <v-card outlined class="pa-4">
      <h6>Impressora</h6>
      <div class="d-flex align-center gap-2">
        <v-select
          :value="selectedPrinter"
          @change="selectPrinter($event)"
          :items="printerList"
          item-text="name"
          item-value="name"
          outlined
          dense
          hide-details
        ></v-select>
        <v-btn icon @click="getPrinters()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </div>
    </v-card>
    <v-card outlined class="pa-4">
      <h6>Configurações</h6>

      <v-select
        :value="settings.paperSize"
        @change="updateSettingsKey({ key: 'paperSize', value: $event })"
        :items="paperSizes"
        label="Tamanho do papel"
        outlined
        dense
        hide-details
      ></v-select>

      <v-switch
        :input-value="settings.cutting"
        @change="updateSettingsKey({ key: 'cutting', value: $event })"
        label="Cortar papel após impressão"
        dense
      ></v-switch>
      <v-select
        :value="settings.cuttingPattern"
        @change="updateSettingsKey({ key: 'cuttingPattern', value: $event })"
        :items="[
          { text: 'Padrão 1', value: '\x1D\x56\x41\x03' },
          { text: 'Padrão 2', value: '\x1D\x56\x31\x03' },
          { text: 'Padrão 3', value: '\x1D\x56\x42\x03' },
          { text: 'Padrão 4 (total)', value: '\x1D\x56\x30\x03' },
        ]"
        :disabled="!settings.cutting"
        label="Padrão de corte"
        outlined
        dense
        hide-details
      ></v-select>

      <v-btn color="primary" class="mt-4" @click="testPrint()">
        Imprimir teste
      </v-btn>
    </v-card>
    <v-card outlined class="pa-4">
      <h6>Margens</h6>

      <div class="d-flex flex-column gap-3 align-center">
        <v-text-field
          :value="settings.margins.top"
          @change="
            setMargin('top', Number($event))
          "
          label="Margem Superior (mm)"
          type="number"
          outlined
          dense
          hide-details
        ></v-text-field>

        <div class="d-flex align-center gap-2">
          <v-text-field
            :value="settings.margins.left"
            @change="
              setMargin('left', Number($event))
            "
            label="Margem Esquerda (mm)"
            type="number"
            outlined
            dense
            hide-details
          ></v-text-field>
          <v-card class="mx-2" flat>
            <div
              style="
                width: 60px;
                height: 60px;
                border: 1px solid #000;
                background-color: #f5f5f5;
              "
            ></div>
          </v-card>
          <v-text-field
            :value="settings.margins.right"
            @change="
              setMargin('right', Number($event))
            "
            label="Margem Direita (mm)"
            type="number"
            outlined
            dense
            hide-details
          ></v-text-field>
        </div>
        <v-text-field
          :value="settings.margins.bottom"
          @change="
            setMargin('bottom', Number($event))
          "
          label="Margem Inferior (mm)"
          type="number"
          outlined
          dense
          hide-details
        ></v-text-field>
      </div>

      <v-btn color="primary" class="mt-4" @click="testPrint()">
        Imprimir teste
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "QZSettings",
  props: {
    qz: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      printerList: [],
      error: null,
      paperSizes: ["80mm", "58mm"],
    };
  },
  computed: {
    ...mapGetters("qz", ["settings", "selectedPrinter"]),
  },
  methods: {
    ...mapActions("qz", ["selectPrinter", "getPrinters", "updateSettingsKey"]),

    async getPrinters(autoselect = false) {
      this.error = null;
      try {
        // if (!this.isActive) throw new Error("QZ Tray is not connected");
        if (autoselect && !this.selectedPrinter) {
          const defaultPrinter = await qz.printers.getDefault();
          this.selectedPrinter = defaultPrinter;
        }

        const printers = await this.qz.printers.find();
        this.printerList = printers;
      } catch (error) {
        this.error = error.message || error;
        console.error("Error getting printers:", error);
      }
    },

    setMargin(key, value) {
      const margins = { ...this.settings.margins, [key]: value };
      this.updateSettingsKey({ key: "margins", value: margins });
    },
    async testPrint() {
      try {
        if (!this.selectedPrinter) throw new Error("No printer selected");

        const config = this.qz.configs.create(this.selectedPrinter);
        const data = [
          "\x1B\x40", // Initialize printer
          "Teste de impressão QZ Tray\n",
          "\n\n\n",
        ];
        if (this.settings.cutting) {
          data.push(this.settings.cuttingPattern);
        }

        await this.qz.print(config, data);
      } catch (error) {
        console.error("Error during test print:", error);
      }
    },
  },
  mounted() {
    this.getPrinters(true);
  },
};
</script>
